import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("legend", { class: "form__legend" }, "Calculate ratio", -1)
const _hoisted_2 = { class: "form__wrapper" }
const _hoisted_3 = { class: "form__item" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "form__label",
  for: "calc-ratio-width"
}, "Width", -1)
const _hoisted_5 = ["aria-invalid"]
const _hoisted_6 = {
  id: "width-ratio-error",
  class: "form__error"
}
const _hoisted_7 = { class: "form__item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "form__label",
  for: "calc-ratio-ratioeight"
}, "Height", -1)
const _hoisted_9 = ["aria-invalid"]
const _hoisted_10 = {
  id: "height-ratio-error",
  class: "form__error"
}
const _hoisted_11 = { class: "form__item" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  class: "form__label",
  for: "calc-ratio-ratio"
}, "Ratio", -1)
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "form__item form__item--submit" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "button__icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 768 768",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      d: "M384 0c-103.241 0-199.79 42.624-270.611 113.389l-113.389-113.389v329.143h329.143l-138.404-138.404c50.578-50.579 119.534-81.024 193.262-81.024 151.241 0 274.285 123.044 274.285 274.285s-123.044 274.285-274.286 274.285c-73.234 0-142.080-28.58-193.92-80.365l-77.568 77.568c72.521 72.521 168.96 112.512 271.488 112.512 211.693 0 384-172.306 384-384 0-211.748-172.306-384-384-384z"
    })
  ])
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Reset Form", -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    class: "form",
    onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.calculateRatio && _ctx.calculateRatio(...args)), ["prevent"]))
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          class: "form__input",
          id: "calc-ratio-width",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.width) = $event)),
          "aria-invalid": _ctx.widthHasError,
          "aria-describedby": "width-ratio-error",
          autocomplete: "off"
        }, null, 8, _hoisted_5), [
          [_vModelText, _ctx.width]
        ]),
        _withDirectives(_createElementVNode("span", _hoisted_6, "Only numbers are allowed!", 512), [
          [_vShow, _ctx.widthHasError]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createElementVNode("input", {
          class: "form__input",
          id: "calc-ratio-ratioeight",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.height) = $event)),
          "aria-invalid": _ctx.heightHasError,
          "aria-describedby": "height-ratio-error",
          autocomplete: "off"
        }, null, 8, _hoisted_9), [
          [_vModelText, _ctx.height]
        ]),
        _withDirectives(_createElementVNode("span", _hoisted_10, "Only numbers are allowed!", 512), [
          [_vShow, _ctx.heightHasError]
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("input", {
          class: "form__input",
          id: "calc-ratio-ratio",
          value: _ctx.ratio,
          readonly: "",
          "aria-live": "polite",
          tabindex: "-1"
        }, null, 8, _hoisted_13)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("button", {
          class: "button",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.calculateRatio && _ctx.calculateRatio(...args)))
        }, "Calculate ratio"),
        _createElementVNode("button", {
          class: "button--round",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
        }, _hoisted_17)
      ])
    ])
  ], 32))
}